export const lineHeight = {
  'font-line-height-xs': 16,
  'font-line-height-sm': 18,
  'font-line-height-md': 20,
  'font-line-height-lg': 22,
  'font-line-height-xl': 24,
  'font-line-height-2xl': 28,
  'font-line-height-3xl': 32,
  'font-line-height-4xl': 36,
  'font-line-height-5xl': 40,
};

export const fontSize = {
  'font-size-7xl': 64,
  'font-size-6xl': 48,
  'font-size-5xl': 40,
  'font-size-4xl': 32,
  'font-size-3xl': 28,
  'font-size-2xl': 24,
  'font-size-xl': 20,
  'font-size-lg': 18,
  'font-size-md': 16,
  'font-size-sm': 14,
  'font-size-xs': 12,
  'font-size-2xs': 10,
};

export const scale = {
    'scale-0': 0,
    'scale-1': 1,
    'scale-2': 2,
    'scale-4': 4,
    'scale-8': 8,
    'scale-12': 12,
    'scale-16': 16,
    'scale-20': 20,
    'scale-24': 24,
    'scale-28': 28,
    'scale-32': 32,
    'scale-36': 36,
    'scale-40': 40,
    'scale-44': 44,
    'scale-48': 48,
    'scale-56': 56,
    'scale-64': 64,
    'scale-999': 999,
  };
  
  